import { Dialog } from "./common";
import { columnName } from "../helpers/column_names";

export const action = "sort-custom";

export class DialogBox extends Dialog{
	open(){
		const isFirst = !this.$dialog;
		super.open();
		if (isFirst) {
			this.getDatalayout().data.attachEvent("onStoreUpdated", (id, obj, mode) => {
				if (!mode || mode === "add" || mode === "delete") {
					this.syncAddButton();
					this.syncScrollviewHeight();
				}
			});
		}
	}
	$show(_box, form){
		this._form = form;

		const area = this.view._table.getSelectArea();
		if (!area || area.start.row == area.end.row)
			return false;

		this.view.$handleSelection = () => false;

		this.setColumns(area);
		this.setUpDataLayout();
	}
	$hide(){
		this.view.$handleSelection = null;
		this._form.clear();
		this.getDatalayout().clearAll();
	}
	$init(){
		const locale = webix.i18n.spreadsheet;
		const margin = webix.skin.$active.layoutMargin.form;
		const height = webix.skin.$active.inputHeight;
		this._maxDLHeight = height * 3 + 4;
		this._columns = [];

		return {
			view: "ssheet-dialog",
			width: 500,
			head: locale.actions["sort-custom"],
			move: true,
			position: "center",
			margin,
			body:{
				view: "form",
				elements: [
					{
						view: "checkbox",
						name: "header",
						label: locale.labels["sort-data-headers"],
						labelWidth: "auto",
						on: {
							onChange: () => this.refreshColumnSelectors()
						}
					},
					{
						view: "scrollview",
						scroll: "auto",
						height,
						borderless: true,
						body: {
							view: "datalayout",
							css: "webix_ssheet_sort_dialog_dl",
							localId: "sortRows",
							rows: [ webix.copy(this.getRows()) ]
						}
					},
					{
						cols: [
							{
								view: "button",
								localId: "addBtn",
								value: locale.labels["add-sort-column"],
								autowidth: true,
								click: () => this.addConfigRow(),
							},
							{}
						]
					}
				]
			},
			on:{
				onSaveClick: () => this.okClick(),
				onCancelClick: () => this.close()
			}
		};
	}
	okClick(){
		const levels = this.getDatalayout().getValue()
			.map(item => ({ column: +item.column, direction: item.direction }));
		const hasHeaders = this._form.elements.header.getValue();

		this.view.callEvent("onCommand", [
			{ id: "sort-multi" },
			{ hasHeaders, levels },
		]);

		this.close();
	}
	syncScrollviewHeight() {                                                                                                                                                                    
		const dl = this.getDatalayout();
		dl.adjust(); // after remove(), the height does not get smaller on its own
		const sv = dl.getParentView();
		sv.define("height", Math.min(dl.$height, this._maxDLHeight));
		sv.resize();
	} 

	setUpDataLayout(){
		const locale = webix.i18n.spreadsheet.labels;
		const dl = this.getDatalayout();
		dl.setValue([{ column: this._columns[0].id, label: locale["sort-by"], direction: "asc" }]);
		this.setAllColumnOptions();
	}

	getRows(){
		const locale = webix.i18n.spreadsheet.labels;
		const radioWidth = webix.skin.$name == "mini" || webix.skin.$name == "compact" ? 130 : 148;
		return {
			view: "form",
			padding: 0,
			borderless: true,
			elements: [
				{
					margin: 10,
					padding: { right: 4 },
					cols: [
						{ view: "label", name: "label", width: 86 },
						{
							view: "richselect",
							name: "column",
							suggest: {
								body: {
									template: obj => {
										const hasHeader = this.getHeader().getValue();
										return (hasHeader && obj.header) ? obj.header : `${locale["column"]} ${obj.value}`;
									},
									data: []
								}
							}
						},
						{
							view: "radio",
							name: "direction",
							width: radioWidth,
							options: [
								{ id: "asc",  value: locale["sort-dir-asc"] },
								{ id: "desc", value: locale["sort-dir-desc"] }
							]
						},
						{
							view: "icon",
							css: "webix_ssheet_cformat_icon",
							name: "delete",
							icon: "wxi-trash",
							click: vid => this.deleteConfigRow(vid)
						}
					]
				}
			]
		};
	}

	addConfigRow() {
		const locale = webix.i18n.spreadsheet.labels;
		const dl = this.getDatalayout();
		const initialColId = this.getFirstUnselectedColumn();
		dl.add({ label: locale["sort-by-next"], column: initialColId, direction: "asc" });

		this.setAllColumnOptions();
	}

	deleteConfigRow(vid){
		const form = webix.$$(vid).getFormView();
		const dl = this.getDatalayout();
		const index = dl.getChildViews().indexOf(form);
		dl.remove(dl.getIdByIndex(index));

		this.setAllColumnOptions();
	}

	setColumns(area) {
		const start = area.start.column;
		const end = area.end.column;
		const headerRow = area.start.row;
		const columns = [];
		for (let i = start; i <= end; i++) {
			columns.push({
				id: i,
				value: columnName(i),
				header: this.view.getCellValue(headerRow, i, false)
			});
		}
		this._columns = columns;
	}

	setAllColumnOptions() {
		this.getDatalayout().getChildViews().forEach(form => {
			this.setColumnOptions(form);
		});
	}

	setColumnOptions(form){
		const sel = form.elements.column;
		const current = sel.getValue();
		const list = sel.getPopup().getList();
		list.clearAll();
		list.parse(webix.copy(this._columns));
		if (current) sel.setValue(current);
	}

	getFirstUnselectedColumn() {
		const selected = new Set(
			this.getDatalayout().getValue().map(item => +item.column)
		);
		return (this._columns.find(c => !selected.has(c.id)) || this._columns[0]).id;
	}

	getDatalayout() {
		return this._dataLayout || (this._dataLayout = this._form.queryView({ localId: "sortRows" }));
	}

	syncAddButton() {
		const limit = Math.max(this._columns.length, 10);
		const btn = this.getAddButton();
		if (this.getDatalayout().count() >= limit)
			btn.hide();
		else
			btn.show();
	}

	refreshColumnSelectors(){
		this.getDatalayout().getChildViews()
			.forEach(f => {
				const select = f.elements.column;
				select.refresh();
				select.getPopup().getList().refresh();
			});
	}

	getAddButton(){
		return this._addButton = (this._addButton || this._form.queryView({ localId: "addBtn" }));
	}

	getHeader() {
		return this._header || (this._header = this._form.elements.header);
	}
}
